import React from "react";
import { Box as NBox, IBoxProps } from "native-base";

export const Box: React.FC<IBoxProps> = (props) => {
  return <NBox {...props} />;
};

export default Box;
